import { useTypewriter } from '@/hooks/Commons/useTypewriter'
import { HighlightedTypewriterTextProps } from '@/interfaces/typewriter'
import { renderHighlightedText } from '@/libs/commons/renderHighlightedText'
import { Typography, useTheme } from '@mui/material'
import React from 'react'

export const TypewriterText: React.FC<HighlightedTypewriterTextProps> = ({
  text,
  onComplete,
  delay,
  highlightWords = [],
  highlightColor,
  ...props
}) => {
  const { displayText } = useTypewriter(text, { delay, onComplete })
  const theme = useTheme()
  const finalHighlightColor = highlightColor || theme.palette.warning.dark

  return (
    <Typography
      {...props}
      dangerouslySetInnerHTML={{
        __html: renderHighlightedText(displayText as string, highlightWords, finalHighlightColor),
      }}
    />
  )
}
